module.exports = __webpack_public_path__ + "media/images/sales/weddingday/thumb-pricing-01-27bdc673150e88c85dc61cf8baf8e12d.svg";